import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=4926cc32&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=ts&"
export * from "./Header.vue?vue&type=script&lang=ts&"
import style0 from "./Header.vue?vue&type=style&index=0&id=4926cc32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4926cc32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4926cc32')) {
      api.createRecord('4926cc32', component.options)
    } else {
      api.reload('4926cc32', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=4926cc32&scoped=true&", function () {
      api.rerender('4926cc32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/Header.vue"
export default component.exports